import { useEffect, useMemo } from "react";
import { debounce } from "lodash";
import { Label } from "../../ui/label";

type Props = {
  inputRef: any;
  attribute: string;
  placeholder: string;
  attributeType: string;
  handleInputChange: (property: string, value: string) => void;
};

const Color = ({
  inputRef,
  attribute,
  placeholder,
  attributeType,
  handleInputChange,
}: Props) => {
  const debouncedChange = useMemo(
    () =>
      debounce((value: string) => {
        handleInputChange(attributeType, value);
      }, 100),
    [attributeType, handleInputChange]
  );

  useEffect(() => {
    return () => {
      debouncedChange.cancel(); // clean up on unmount
    };
  }, [debouncedChange]);

  if (!inputRef || !attribute || typeof attribute !== "string") return null;

  return (
    <div className="flex flex-col gap-3 border-b border-borderColor py-5 px-2">
      <h3 className="text-[10px] uppercase px-1">{placeholder}</h3>
      <div
        className="flex items-center h-10 gap-2 rounded-lg border border-grey-200"
        onClick={() => inputRef.current.click()}
      >
        <input
          type="color"
          value={attribute || "#ffffff"}
          ref={inputRef}
          onChange={(e) => debouncedChange(e.target.value)}
          className="rounded-l-lg h-full"
        />
        <Label className="flex-1">{attribute || "#ffffff"}</Label>
      </div>
    </div>
  );
};

export default Color;
